import React from 'react'
import { useOfferLink, TYPE_LINK } from 'cityads-v3/hooks/offers'
import { Link } from 'react-router-dom';
import classes from './OfferCard.scss'
import Skeleton from '@mui/material/Skeleton'
import Typography from '@mui/material/Typography'
import { Coupon } from 'cityads-v3/types/coupon';
import { Offer } from 'cityads-v3/types/offers';

type OfferCardTitleProps = {
  entity: Offer | Coupon
  plainTitle: boolean
  linkSource: string
}

export default function OfferCardTitle({ entity, plainTitle, linkSource }: OfferCardTitleProps) {
  const offerTitle = entity
    ? 'translated_name' in entity
      ? entity.translated_name
      : entity.name
    : ''
  const [link, linkType] = useOfferLink(entity?.id, linkSource);

  const linkForTitle = linkType === TYPE_LINK ?
    <Link className={classes.offerTitle} to={link}><Typography variant="body1" color="text.primary" noWrap>{offerTitle}</Typography></Link> :
    <a className={classes.offerTitle} href={link as string}><Typography variant="body1" color="text.primary" noWrap>{offerTitle}</Typography></a>;

  return entity ?
    (
      plainTitle ?
        <Typography color="text.primary">{offerTitle}</Typography>
        : linkForTitle
    )
    :
    <Skeleton animation="wave" variant="text" width={120} height={22} />
}
